import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon } from 'lucide-react';
interface CareerLevel {
  level: string;
  rentals: string;
  sales: string;
  description: string;
  color: string;
}
interface CareerTableProps {
  levels: CareerLevel[];
}
export function CareerTable({
  levels
}: CareerTableProps) {
  return <div className="space-y-4" data-id="element-507">
      {levels.map((level, index) => <motion.div key={level.level} initial={{
      opacity: 0,
      x: -20
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.4,
      delay: index * 0.1
    }} whileHover={{
      scale: 1.02,
      x: 10
    }} className={`bg-gradient-to-r ${level.color} rounded-2xl p-6 shadow-md hover:shadow-xl transition-all border-2 border-gray-200 cursor-pointer`} data-id="element-508">
          <div className="flex items-start justify-between gap-4" data-id="element-509">
            <div className="flex-1" data-id="element-510">
              <div className="flex items-center space-x-3 mb-3" data-id="element-511">
                <TrendingUpIcon className="w-6 h-6 text-[#132C53]" data-id="element-512" />
                <h3 className="text-xl font-bold text-[#132C53]" data-id="element-513">
                  {level.level}
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-514">{level.description}</p>
              <div className="flex flex-wrap gap-4" data-id="element-515">
                <div className="bg-white bg-opacity-60 px-4 py-2 rounded-lg" data-id="element-516">
                  <p className="text-xs font-medium text-gray-600 mb-1" data-id="element-517">
                    Închirieri
                  </p>
                  <p className="text-lg font-bold text-[#132C53]" data-id="element-518">
                    {level.rentals}
                  </p>
                </div>
                <div className="bg-white bg-opacity-60 px-4 py-2 rounded-lg" data-id="element-519">
                  <p className="text-xs font-medium text-gray-600 mb-1" data-id="element-520">
                    Vânzări
                  </p>
                  <p className="text-lg font-bold text-[#132C53]" data-id="element-521">
                    {level.sales}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0 w-12 h-12 bg-[#132C53] bg-opacity-10 rounded-full flex items-center justify-center" data-id="element-522">
              <span className="text-2xl font-bold text-[#132C53]" data-id="element-523">
                {index + 1}
              </span>
            </div>
          </div>
        </motion.div>)}
    </div>;
}